import {
    GET_CANCELLATION_POLICY_CONSTANTS_REQUEST,
    GET_CANCELLATION_POLICY_CONSTANTS_RESPONSE,
    GET_MIMAR_CONSTANTS_REQUEST,
    GET_MIMAR_CONSTANTS_RESPONSE,
    UPDATE_APP_CONSTANTS,
} from './types'

export const getCancelationConstantsRequest = (payload) => ({
    type: GET_CANCELLATION_POLICY_CONSTANTS_REQUEST,
    payload
});
export const getCancelationConstantsResponse = (payload) => ({
    type: GET_CANCELLATION_POLICY_CONSTANTS_RESPONSE,
    payload
});

export const getMimarConstantsRequest = (payload) => ({
    type: GET_MIMAR_CONSTANTS_REQUEST,
    payload
});
export const getMimarConstantsResponse = (payload) => ({
    type: GET_MIMAR_CONSTANTS_RESPONSE,
    payload
});

export const updateAppConstants = (payload) => ({
    type: UPDATE_APP_CONSTANTS,
    payload
})




